"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatString = void 0;
const formatString = (str, ...args) => {
    let matches = -1;
    return str.replace(/\?\?/g, () => {
        matches += 1;
        return args[matches] || '';
    });
};
exports.formatString = formatString;
